import { patchState, signalStore, withMethods } from "@ngrx/signals";
import { setEntity, withEntities } from "@ngrx/signals/entities";
import {
    setError,
    setFulfilled,
    setPending,
    withRequestStatus,
} from "../extensions/request-status.feature";
import { inject } from "@angular/core";
import { Observable, of, tap } from "rxjs";
import { UserBackofficeViewModel } from "@playcharge/common/models/backend/users/backoffice/user-backoffice-view-model";
import { ApiUsersService } from "../../services/api-users.service";

export type UsersStore = InstanceType<typeof UsersStore>;

export const UsersStore = signalStore(
    { providedIn: "root", protectedState: false },
    withEntities<UserBackofficeViewModel>(),
    withRequestStatus(),
    withMethods((store, apiUsersService = inject(ApiUsersService)) => ({
        getByEmail(email: string): Observable<UserBackofficeViewModel> {
            const cached = store.entityMap()[email];

            if (cached) {
                return of(cached);
            }

            patchState(store, setPending());

            return apiUsersService.getByEmail(email).pipe(
                tap({
                    next: (user) => {
                        patchState(store, setEntity(user, { selectId: (user) => user.email }));
                        patchState(store, setFulfilled());
                    },
                    error: (error) => patchState(store, setError(error.error.error)),
                }),
            );
        },
    })),
);
